export const runLimitTrackerPermissions = {
  RUN_LIMIT_TRACKER_VIEW: {
    enabled: ['run_limit_tracker_view'],
  },
};
